// modules
import { createSelector } from 'reselect'

// utils
import { get } from 'lodash'

const activities = (state = {}) => get(state, ['activities'], {})

export const activitiesList$ = createSelector(activities, (activities = {}) =>
  get(activities, ['activitiesList'], [])
)

export const activitiesStatistics$ = createSelector(
  activities,
  (activities = {}) => get(activities, ['activitiesStatistics'], {})
)
